/**
 * Products initial values for the redux state.
 */
export const INITIAL_STATE = {
  locations: [],
  location: null,
  error: false
};
